import { WebPNextImage } from '@/components/WebPImage';
import styles from './style.module.scss';
import { useRouter } from 'next/router';
import { Button } from 'antd';
import Link from 'next/link';
import FadeIn from '@/components/commonComponents/fadeIn';

type ActivitySummaryProps = {
  title: string;
  contents: SummaryInfo[];
};

const SummaryItem = (props: SummaryInfo): JSX.Element => {
  const router = useRouter();
  const {
    title,
    timestamp,
    location,
    summary,
    primaryLink,
    minorLink,
    image,
    description,
  } = props;

  return (
    <div className={styles['item']}>
      <div className={styles['image-container']}>
        <WebPNextImage src={image} layout="fill" />
      </div>
      <div className={styles['summary-content']}>
        <div className={styles['text-group']}>
          <div className={styles['title']}>{title}</div>
          <div className={styles['line']}>
            <div className={styles['description']}>{description}</div>
            <div className={styles['info']}>
              {timestamp} | {location}
            </div>
          </div>
          <div className={styles['summary']}>
            {summary.map((s) => (
              <div className={styles['summary-item']} key={s.label}>
                <div className={styles['summary-item-label']}>{s.label}</div>
                <div className={styles['summary-item-content']}>
                  {s.content}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={styles['btn-group']}>
          <Link href={primaryLink.url} style={{ marginRight: 12 }}>
            <Button type="primary" className={styles['button']}>
              {primaryLink.title}
            </Button>
          </Link>
          <Link href={minorLink.url}>
            <Button className={styles['button']}>{minorLink.title}</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

const ActivitySummary = (props: ActivitySummaryProps) => {
  const { title, contents } = props;
  return (
    <div className={styles['container']}>
      <FadeIn>
        <div className={styles['title']}>{title}</div>
      </FadeIn>
      <div className={styles['content']}>
        {contents.map((item) => (
          <FadeIn key={item.title}>
            <SummaryItem {...item} />
          </FadeIn>
        ))}
      </div>
    </div>
  );
};

export default ActivitySummary;

<div className="content">
  <div></div>
  <div className="reveal">
    <div className="item"></div>
  </div>
  <div></div>
  <div className="reveal">
    <div className="item"></div>
  </div>
</div>;
